(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-content-cards"] && !Shopify.designMode) return;
  try {
    
  // If autoplay enabled, play the video only if the video is visible.
  document.querySelectorAll('.js-video').forEach((video) => {
    if (video.attributes.autoplay !== undefined ) {
      let isPaused = false; /* Flag for auto-paused video */
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio != 1  && !video.paused) {
            video.pause();
            isPaused = true;
          }
          else if (isPaused) {
            video.play();
            isPaused = false
          }
        });
      }, {threshold: 1});
      observer.observe(video);
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-content"] && !Shopify.designMode) return;
  try {
    
  // If autoplay enabled, play the video only if the video is visible.
  document.querySelectorAll('.js-video').forEach((video) => {
    if (video.attributes.autoplay !== undefined ) {
      let isPaused = false; /* Flag for auto-paused video */
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio != 1  && !video.paused) {
            video.pause();
            isPaused = true;
          }
          else if (isPaused) {
            video.play();
            isPaused = false
          }
        });
      }, {threshold: 1});
      observer.observe(video);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
